import React, { useEffect, useState } from "react";
import { Header } from "./styles";

const ThankYouHeader = (props) => {
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		setFirstName(params.get("firstname"));
		setLastName(params.get("lastname"));
	}, []);
	const { headerText, enableEnhancedConversion } = props;
	return (
		<>
			<Header>
				{enableEnhancedConversion && firstName && lastName && (
					<div className="name-wrapper">
						<div className="first-name">{firstName}</div>
						<div className="last-name">{lastName}</div>
					</div>
				)}
				{headerText}
			</Header>
		</>
	);
};

export default ThankYouHeader;
